import { writable } from 'svelte/store';

export function creatingToastStore() {
   const  { subscribe, set, update }  = writable({ 
    message: '', 
    title: '',
    type: '' 
  })


async function showToast(message, type = 'info', title = '') {
  toast.set({ message, type, title });
  update(state => ({ ...state, message, type, title }));
}

async function hideToast() {
  toast.set({ message: '', type: '', title: '' });
  update(state => ({ ...state, message: '', type: '', title: '' }));
} 

return {
  subscribe,
  set,  
  update, showToast, hideToast };
}

export const toast = creatingToastStore();
